module.exports = __webpack_public_path__ + "static/img/kefu.433f50e3.jpg";